export enum ReportTypes {
    GET_REPORT_LOADING = "GET_REPORT_LOADING",
    GET_REPORT_SUCCESS = "GET_REPORT_SUCCESS",
    GET_REPORT_FAILURE = "GET_REPORT_FAILURE"
}
